import { Col, Row } from "reactstrap";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";
import AppModal from "../../Common/AppModal";

import {
  addVatPeriod,
  addVatPeriodSuccess,
  createYearEndPeriod,
  createYearEndPeriodSuccess,
  getVatPeriodList,
  getYearEndPeriodList,
  updateVatPeriod,
  updateVatPeriodSuccess,
  updateYearEndPeriodDetails,
  updateYearEndPeriodDetailsSuccess,
} from "../../../store/actions";
import { AppDatePicker } from "../../Common/AppDateTimePicker";
import { handleDateFormat } from "../../Common/HandleDateTime";
import moment from "moment";
import YearEndPeriod from "../../../store/YearEndPeriod/reducer";

export default function CreateEditPeriod({
  modal,
  setModal,
  toggle,
  isEdit,
  periodDetails,
  reportName,
}) {
  const dispatch = useDispatch();
  // add 3 Months - 1 day
  const handleTodayPlus3Months = () => {
    // use moment
    return moment().add(3, "months").subtract(1, "days").format("YYYY-MM-DD");
  };
  // add 12 months -1 day
  const handleTodayPlus12Months = () => {
    return moment().add(12, "months").subtract(1, "days").format("YYYY-MM-DD");
  };

  const defaultPeriodData = {
    StartDate: handleDateFormat(new Date()),
    // EndDate: handleTodayPlus3Months(),
    ...(reportName === "vatPeriod" && { EndDate: handleTodayPlus3Months() }),
    ...(reportName === "yearEndPeriod" && {
      EndDate: handleTodayPlus12Months(),
    }),
    FlagLockedUsers: null,
    FlagLockedAdvisors: null,
    LockedUsersDateTime: null,
    Notes: "",
  };

  const [periodData, setPeriodData] = useState(defaultPeriodData);
  useEffect(() => {
    if (!isEdit) return;
    if (isEmpty(periodDetails)) return;
    setPeriodData({
      Id: periodDetails?.Id,
      StartDate: periodDetails?.StartDate,
      EndDate: periodDetails?.EndDate,
      FlagLockedUsers: periodDetails?.FlagLockedUsers,
      FlagLockedAdvisors: periodDetails?.FlagLockedAdvisors,
      LockedUsersDateTime: periodDetails?.LockedUsersDateTime,
      Notes: periodDetails?.Notes,
    });
  }, [periodDetails, isEdit]);

  const handleCreateUpdateVatPeriod = (type) => {
    // check if all fields are filled
    // Staff

    // StartDateTime
    if (isEmpty(periodData.StartDate)) {
      toast.error("Please Select Start Date");
      return;
    }
    if (isEmpty(periodData.EndDate)) {
      toast.error("Please Select Start Date");
      return;
    }

    switch (reportName) {
      case "vatPeriod":
        if (type === "create") {
          dispatch(addVatPeriod([periodData]));
        }
        if (type === "update") {
          dispatch(updateVatPeriod([periodData]));
        }
        break;
      case "yearEndPeriod":
        if (type === "create") {
          dispatch(createYearEndPeriod([periodData]));
        }
        if (type === "update") {
          dispatch(updateYearEndPeriodDetails([periodData]));
        }
        break;
      default:
        break;
    }
  };

  const {
    addVatPeriodSuccessAPI,
    updateVatPeriodSuccessAPI,
    addVatPeriodLoading,
    updateVatPeriodLoading,
  } = useSelector((state) => ({
    addVatPeriodSuccessAPI: state.GeneralSettings.addVatPeriodSuccess,
    updateVatPeriodSuccessAPI: state.GeneralSettings.updateVatPeriodSuccess,
    addVatPeriodLoading: state.GeneralSettings.addVatPeriodLoading,
    updateVatPeriodLoading: state.GeneralSettings.updateVatPeriodLoading,
  }));
  const {
    createYearEndPeriodSuccessAPI,
    updateYearEndPeriodDetailsSuccessAPI,
  } = useSelector((state) => ({
    createYearEndPeriodSuccessAPI:
      state.YearEndPeriod.createYearEndPeriodSuccess,
    updateYearEndPeriodDetailsSuccessAPI:
      state.YearEndPeriod.updateYearEndPeriodDetailsSuccess,
  }));

  useEffect(() => {
    if (isEmpty(createYearEndPeriodSuccessAPI)) return;
    if (createYearEndPeriodSuccessAPI.status === 200) {
      toast.success(createYearEndPeriodSuccessAPI.message);
      dispatch(getYearEndPeriodList());
      setModal(false);
    } else {
      toast.error(createYearEndPeriodSuccessAPI.message);
    }
    dispatch(createYearEndPeriodSuccess([]));
  }, [createYearEndPeriodSuccessAPI]);

  useEffect(() => {
    if (isEmpty(updateYearEndPeriodDetailsSuccessAPI)) return;
    if (updateYearEndPeriodDetailsSuccessAPI.status === 200) {
      toast.success(updateYearEndPeriodDetailsSuccessAPI.message);
      dispatch(getYearEndPeriodList());
      setModal(false);
    } else {
      toast.error(updateYearEndPeriodDetailsSuccessAPI.message);
    }
    dispatch(updateYearEndPeriodDetailsSuccess([]));
  }, [updateYearEndPeriodDetailsSuccessAPI]);

  useEffect(() => {
    if (isEmpty(addVatPeriodSuccessAPI)) return;
    if (addVatPeriodSuccessAPI?.status === 200) {
      toast.success(addVatPeriodSuccessAPI?.message);
      dispatch(getVatPeriodList());
      setModal(false);
    } else {
      toast.error(addVatPeriodSuccessAPI?.message);
    }
    dispatch(addVatPeriodSuccess([]));
  }, [addVatPeriodSuccessAPI]);

  useEffect(() => {
    if (isEmpty(updateVatPeriodSuccessAPI)) return;
    if (updateVatPeriodSuccessAPI?.status === 200) {
      toast.success(updateVatPeriodSuccessAPI?.message);
      dispatch(getVatPeriodList());
      setModal(false);
    } else {
      toast.error(updateVatPeriodSuccessAPI?.message);
    }
    dispatch(updateVatPeriodSuccess([]));
  }, [updateVatPeriodSuccessAPI]);
  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title={isEdit ? "Edit Period" : "Create New Period"}
      icon={<DateRangeOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      loading={addVatPeriodLoading || updateVatPeriodLoading}
      loadingText="Saving…"
      submitLabel={isEdit ? "Update" : "Create"}
      submitColor="success"
      onSubmit={() =>
        handleCreateUpdateVatPeriod(isEdit ? "update" : "create")
      }
    >
      <Row className="g-3">
            <Col lg={12}>
              <div>
                <div className={"pt-0"}>
                  <div htmlFor="company_name-field" className="form-label">
                    Start period date
                  </div>
                  <div>
                    <AppDatePicker
                      value={
                        periodData.StartDate
                          ? moment(periodData.StartDate, "YYYY-MM-DD")
                          : null
                      }
                      onChange={(val) => {
                        const jsDate =
                          val && val.isValid() ? val.toDate() : null;
                        setPeriodData({
                          ...periodData,
                          StartDate: jsDate ? handleDateFormat(jsDate) : "",
                        });
                      }}
                    />
                  </div>
                  <div htmlFor="company_name-field" className="form-label pt-3">
                    End period date
                  </div>
                  <div>
                    <AppDatePicker
                      value={
                        periodData.EndDate
                          ? moment(periodData.EndDate, "YYYY-MM-DD")
                          : null
                      }
                      onChange={(val) => {
                        const jsDate =
                          val && val.isValid() ? val.toDate() : null;
                        setPeriodData({
                          ...periodData,
                          EndDate: jsDate ? handleDateFormat(jsDate) : "",
                        });
                      }}
                    />
                  </div>
                  <div className={"d-flex pt-4  "}>
                    <div className={"me-2"}>
                      {periodData.FlagLockedUsers === "1" ? (
                        <div
                          className={"text-danger like-href"}
                          onClick={() => {
                            setPeriodData({
                              ...periodData,
                              FlagLockedUsers: null,
                            });
                          }}
                        >
                          <i className="fa-solid fa-lock me-1"></i>
                          <span>User Locked</span>
                        </div>
                      ) : (
                        <div
                          className={"text-success like-href"}
                          onClick={() => {
                            setPeriodData({
                              ...periodData,
                              FlagLockedUsers: "1",
                            });
                          }}
                        >
                          <i className="fa-solid fa-lock-open me-1"></i>
                          <span>User Open</span>
                        </div>
                      )}
                    </div>
                    <div>
                      {periodData.FlagLockedAdvisors === "1" ? (
                        <div
                          className={"text-danger like-href"}
                          onClick={() => {
                            setPeriodData({
                              ...periodData,
                              FlagLockedAdvisors: null,
                            });
                          }}
                        >
                          <i className="fa-solid fa-lock me-1"></i>
                          <span>Advisor Locked</span>
                        </div>
                      ) : (
                        <div
                          className={"text-success like-href"}
                          onClick={() => {
                            setPeriodData({
                              ...periodData,
                              FlagLockedAdvisors: "1",
                            });
                          }}
                        >
                          <i className="fa-solid fa-lock-open me-1"></i>
                          <span>Advisor Open</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={"mt-4"}>
                    <label>Notes</label>{" "}
                    <textarea
                      className="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      value={periodData.Notes}
                      onChange={(e) => {
                        setPeriodData({
                          ...periodData,
                          Notes: e.target.value,
                        });
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
    </AppModal>
  );
}
